import { IconButton, Menu } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": { minWidth: "12rem" },
  "& .MuiButtonBase-root": {
    lineHeight: "1.4",
    fontWeight: "600",
    fontSize: "1rem",
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
}));
